module.exports = __webpack_public_path__ + "roadmap-nux-8a3ba7f867560d9b7cbd2ecbb4a20cd6.jpg";